import AHDate from "_shared/dates/date";
import Guid from "_shared/guids/guid";
import ReadReceiptSchema, {
  ReadReceiptJSON,
  ReadReceiptParams,
} from "messaging/read-receipts/_schemas/read-receipt-schema";

export default class ReadReceipt {
  public static fromJSON(json: ReadReceiptJSON | null | undefined): ReadReceipt | null | undefined {
    if (!json) return json;
    const validated = ReadReceiptSchema.deserialize(json);
    return new ReadReceipt(validated);
  }
  public readonly userId: Guid;
  public readonly seenAt: AHDate;

  public constructor(params: ReadReceiptParams) {
    this.userId = params.userId;
    this.seenAt = params.seenAt;
  }

  public toJSON(): ReadReceiptJSON {
    return ReadReceiptSchema.serialize(this);
  }
}
